export const DEPOSITION_DATA = {
  'GMAW - Solid Wire': {
    wire_densities: {
      0.035: 3650,
      0.045: 2210,
      0.052: 1680,
      '1/16': 1160,
      '5/64': 730,
      '3/32': 519,
      '1/8': null,
      '5/32': null,
    },
    transfer_types: {
      'SG-AC-10': 'Spray',
      'SG-AC-15': 'Spray',
      'SG-AC-25': 'Short-Circuit',
      'SG-C': 'Short-Circuit',
      'SAW-Flux': null,
    },
    efficiencies: {
      'SG-AC-10': 97,
      'SG-AC-15': 96,
      'SG-AC-25': 92,
      'SG-C': 88,
      'SAW-Flux': null,
    },
  },
  'GMAW - Metal Core': {
    wire_densities: {
      0.035: 3750,
      0.045: 2250,
      0.052: 1700,
      '1/16': 1225,
      '5/64': 900,
      '3/32': 520,
      '1/8': null,
      '5/32': null,
    },
    transfer_types: {
      'SG-AC-10': 'Spray',
      'SG-AC-15': 'Spray',
      'SG-AC-25': 'Spray',
      'SG-C': 'Short-Circuit',
      'SAW-Flux': null,
    },
    efficiencies: {
      'SG-AC-10': 97,
      'SG-AC-15': 96,
      'SG-AC-25': 95,
      'SG-C': 86,
      'SAW-Flux': null,
    },
  },
  'Flux Core - Gas-Shielded': {
    wire_densities: {
      0.035: 4800,
      0.045: 2750,
      0.052: 2000,
      '1/16': 1450,
      '5/64': 920,
      '3/32': 660,
      '1/8': null,
      '5/32': null,
    },
    transfer_types: {
      'SG-AC-10': 'Spray',
      'SG-AC-15': 'Spray',
      'SG-AC-25': 'Spray',
      'SG-C': 'Globular',
      'SAW-Flux': null,
    },
    efficiencies: {
      'SG-AC-10': 90,
      'SG-AC-15': 89,
      'SG-AC-25': 88,
      'SG-C': 86,
      'SAW-Flux': null,
    },
  },
  'SAW - Solid Wire': {
    wire_densities: {
      0.035: null,
      0.045: null,
      0.052: null,
      '1/16': null,
      '5/64': 740,
      '3/32': 530,
      '1/8': 300,
      '5/32': 190,
    },
    transfer_types: {
      'SG-AC-10': null,
      'SG-AC-15': null,
      'SG-AC-25': null,
      'SG-C': null,
      'SAW-Flux': 'Globular',
    },
    efficiencies: {
      'SG-AC-10': null,
      'SG-AC-15': null,
      'SG-AC-25': null,
      'SG-C': null,
      'SAW-Flux': 99,
    },
  },
  'SAW - Cored Wire': {
    wire_densities: {
      0.035: null,
      0.045: null,
      0.052: null,
      '1/16': null,
      '5/64': 850,
      '3/32': 575,
      '1/8': 355,
      '5/32': 225,
    },
    transfer_types: {
      'SG-AC-10': null,
      'SG-AC-15': null,
      'SG-AC-25': null,
      'SG-C': null,
      'SAW-Flux': 'Globular',
    },
    efficiencies: {
      'SG-AC-10': null,
      'SG-AC-15': null,
      'SG-AC-25': null,
      'SG-C': null,
      'SAW-Flux': 99,
    },
  },
};

/**
 * Get available wire diameters for a weld process
 * @param {string} weldProcess - The weld process name
 * @returns {Array} Array of {label, value} objects for wire diameters
 */
export function getWireDiameters(weldProcess) {
  if (!DEPOSITION_DATA[weldProcess]) return [];

  const densities = DEPOSITION_DATA[weldProcess].wire_densities;
  return Object.entries(densities)
    .filter(([, value]) => value !== null)
    .map(([label, value]) => ({ label, value }));
}

/**
 * Get available shielding gas options for a weld process
 * @param {string} weldProcess - The weld process name
 * @returns {Array} Array of {label, value} objects for shielding gas
 */
export function getShieldingGasOptions(weldProcess) {
  if (!DEPOSITION_DATA[weldProcess]) return [];

  const efficiencies = DEPOSITION_DATA[weldProcess].efficiencies;
  return Object.entries(efficiencies)
    .filter(([, value]) => value !== null)
    .map(([label, value]) => ({ label, value }));
}

/**
 * Get transfer type for a weld process and shielding gas
 * @param {string} weldProcess - The weld process name
 * @param {string} shieldingGasLabel - The shielding gas label
 * @returns {string|null} The transfer type
 */
export function getTransferType(weldProcess, shieldingGasLabel) {
  if (!DEPOSITION_DATA[weldProcess]) return null;
  return DEPOSITION_DATA[weldProcess].transfer_types[shieldingGasLabel] || null;
}
